// extracted by mini-css-extract-plugin
module.exports = {"list":"_33974c2b58--list--WBiF_","row":"_33974c2b58--row--dEf_K"};